import { useSyncExternalStore } from 'react';
import { localeStore } from './locale-store';
import type { Locale } from './locales';

export function useLocale(): Locale {
  return useSyncExternalStore(localeStore.subscribe, localeStore.read);
}
